module.exports = __webpack_public_path__ + "img/tpc-13.1f1795e1.jpg";